
window.onload = function() {
    configurator.render();
    nestingManager.enforce();
    configurator.handleEvent(configurator.getAttributeValue("ue"), "click");
}

window.onUnload = function() {
    configurator.destroy();
    configuratorRenderer.destroy();
    nestingManager.destroy();
}

configurator.doPreEvent = function(object, type) {}
configurator.doPostEvent = function(object, type) {
	if (type == "click") {
        if (object.attribute && object.attribute.id === "aUnit") {
            if (!object.isSelected) {
                document.getElementById("desiredCenterContainer").style.display = "none";
                document.getElementById("resultsTableEnglish").style.display = "none";
                document.getElementById("resultsTableMetric").style.display = "none";
                document.getElementById("desiredCenterInput").value = "";
            } else {
                document.getElementById("desiredCenterContainer").style.display = "";
                if (object.id === "ue") {
                    document.getElementById("desiredCenterHeader").innerHTML = "Desired Center Distance (in)";
                    document.getElementById("resultsTableEnglish").style.display = "";
                    document.getElementById("resultsTableMetric").style.display = "none";
                } else {
                    document.getElementById("desiredCenterHeader").innerHTML = "Desired Center Distance (mm)";
                    document.getElementById("resultsTableEnglish").style.display = "none";
                    document.getElementById("resultsTableMetric").style.display = "";
                }
            }
        }

        onChangeCenterDistance();
	}
}

function onClickReset() {
    var a, u;
    document.getElementById("desiredCenterInput").value = "";
    a = configurator.getAttribute("aUnit");
    u = a.getValue();
    configurator.setValue(null);
    a.setValue(u[0].id);
}

var desiredCenterDistance = 0;
function onChangeCenterDistance() {
    var v, e = document.getElementById("desiredCenterInput");

    desiredCenterDistance = 0;

    if (e.value === "") {
        setAttributeTable();
        return;
    }

    v = parseFloat(e.value);
    if (isNaN(v) || v <= 0) {
        alert("Please enter a positive value for the Desired Center Distance.");
        e.value = "";
        e.focus();
        setAttributeTable();
        return;
    }

    desiredCenterDistance = v;
    setAttributeTable();
}

function setAttributeTable() {
    var v, vm, teethA, teethB, speedRatio,
        pitch, pitchDiameterA, pitchDiameterB,
        theta, costheta, englishDesiredCD, desiredBeltLength, beltLength, beltLengthMetric,
        beltTeeth, centerDistance, teethInMesh, filter;

    // teeth
    teethA = (configurator.getAttribute("aTeethA").selectedValue) ? configurator.getAttribute("aTeethA").selectedValue.label : null;
    teethB = (configurator.getAttribute("aTeethB").selectedValue) ? configurator.getAttribute("aTeethB").selectedValue.label : null;

    // speed ratio
    speedRatio = (teethA && teethB) ? teethB / teethA : null;

    // pitch diameters
    pitch = (configurator.getAttribute("aToothStyle").selectedValue) ? pitchList[configurator.getAttribute("aToothStyle").selectedValue.id] : null;
    pitchDiameterA = (pitch && teethA) ? teethA * pitch / Math.PI : null;
    pitchDiameterB = (pitch && teethB) ? teethB * pitch / Math.PI : null;

    // belt length
    englishDesiredCD = (configurator.getAttributeValue("ue").isSelected) ? desiredCenterDistance : desiredCenterDistance / 25.4;
    if (desiredCenterDistance > 0 && pitchDiameterA && pitchDiameterB &&
            (configurator.getAttribute("aBeltWidthEnglish").selectedValue ||
            configurator.getAttribute("aBeltWidthMetric").selectedValue)) {
        theta = Math.asin((pitchDiameterA - pitchDiameterB) / (2 * englishDesiredCD));
        costheta = Math.cos(Math.asin((pitchDiameterA - pitchDiameterB) / (2 * englishDesiredCD)));
        desiredBeltLength = 2 * englishDesiredCD * costheta +
                Math.PI * (pitchDiameterA + pitchDiameterB) / 2 +
                theta * (pitchDiameterA - pitchDiameterB);

        // find the first available belt length which is greater than the
        // desired one (or the max belt length if desired is larger than
        // all of them)
        v = (configurator.getAttribute("aBeltWidthEnglish").selectedValue) ?
                availablePitchLengths[configurator.getAttribute("aToothStyle").selectedValue.id +
                                      configurator.getAttribute("aBeltWidthEnglish").selectedValue.id] :
                availablePitchLengths[configurator.getAttribute("aToothStyle").selectedValue.id +
                                      configurator.getAttribute("aBeltWidthMetric").selectedValue.id];
        vm = (configurator.getAttribute("aBeltWidthEnglish").selectedValue) ?
                availablePitchLengthsMetric[configurator.getAttribute("aToothStyle").selectedValue.id +
                                      configurator.getAttribute("aBeltWidthEnglish").selectedValue.id] :
                availablePitchLengthsMetric[configurator.getAttribute("aToothStyle").selectedValue.id +
                                      configurator.getAttribute("aBeltWidthMetric").selectedValue.id];
        beltLength = v[v.length - 1];
        beltLengthMetric = 0;
        for (i = 0; i < v.length; i++) {
            if (v[i] >= desiredBeltLength) {
                beltLength = v[i];
                beltLengthMetric = vm[i];
                break;
            }
        }
    }

    // belt teeth
    beltTeeth = (beltLength && pitch) ? Math.round(beltLength / pitch) : null;

    // center distance
    if (beltLength && pitchDiameterA && pitchDiameterB) {
        v = 4 * beltLength - 6.28 * (pitchDiameterA + pitchDiameterB);
        centerDistance = (v + Math.sqrt(v * v - 32 * (pitchDiameterA - pitchDiameterB) * (pitchDiameterA - pitchDiameterB))) / 16;
    }

    // teeth in mesh
    teethInMesh = (pitchDiameterA && pitchDiameterB && centerDistance && teethB) ? Math.floor((0.5 - ((pitchDiameterA - pitchDiameterB) / (6 * centerDistance))) * teethB) : null;

    // display
    if (configurator.getAttributeValue("ue").isSelected) {
        if (speedRatio) {
            document.getElementById("elementIdSpeedRatioEnglish").innerHTML = speedRatio.toFixed(2);
        } else {
            document.getElementById("elementIdSpeedRatioEnglish").innerHTML = "&nbsp;";
        }
        if (pitchDiameterA) {
            document.getElementById("elementIdPitchAEnglish").innerHTML = pitchDiameterA.toFixed(3);
        } else {
            document.getElementById("elementIdPitchAEnglish").innerHTML = "&nbsp;";
        }
        if (pitchDiameterB) {
            document.getElementById("elementIdPitchBEnglish").innerHTML = pitchDiameterB.toFixed(3);
        } else {
            document.getElementById("elementIdPitchBEnglish").innerHTML = "&nbsp;";
        }
        if (desiredBeltLength && beltLength) {
            document.getElementById("elementIdDesiredBeltPitchEnglish").innerHTML = desiredBeltLength.toFixed(3);
            document.getElementById("elementIdBeltPitchEnglish").innerHTML = beltLength.toFixed(3);
        } else {
            document.getElementById("elementIdDesiredBeltPitchEnglish").innerHTML = "&nbsp;";
            document.getElementById("elementIdBeltPitchEnglish").innerHTML = "&nbsp;";
        }
        if (beltTeeth) {
            document.getElementById("elementIdBeltTeethEnglish").innerHTML = beltTeeth;
        } else {
            document.getElementById("elementIdBeltTeethEnglish").innerHTML = "&nbsp;";
        }
        if (centerDistance) {
            document.getElementById("elementIdActualCenterDistanceEnglish").innerHTML = centerDistance.toFixed(3);
        } else {
            document.getElementById("elementIdActualCenterDistanceEnglish").innerHTML = "&nbsp;";
        }
        if (teethInMesh) {
            document.getElementById("elementIdTeethInMeshEnglish").innerHTML = teethInMesh;
            if (teethInMesh < 6) {
                document.getElementById("teethInMeshWarningEnglish").innerHTML = "* Warning: A value for teeth in mesh below 6 may not be suitable for most applications.";
                document.getElementById("elementIdTeethInMeshEnglish").className = "teethInMeshOob";
                document.getElementById("teethInMeshWarningEnglish").className = "teethInMeshOob";
            } else {
                document.getElementById("teethInMeshWarningEnglish").innerHTML = "&nbsp;";
                document.getElementById("elementIdTeethInMeshEnglish").className = "teethInMeshNorm";
                document.getElementById("teethInMeshWarningEnglish").className = "teethInMeshNorm";
            }
        } else {
            document.getElementById("elementIdTeethInMeshEnglish").innerHTML = "&nbsp;";
            document.getElementById("teethInMeshWarningEnglish").innerHTML = "&nbsp;";
            document.getElementById("elementIdTeethInMeshEnglish").className = "teethInMeshNorm";
            document.getElementById("teethInMeshWarningEnglish").className = "teethInMeshNorm";
        }
    } else {
        if (speedRatio) {
            document.getElementById("elementIdSpeedRatioMetric").innerHTML = speedRatio.toFixed(2);
        } else {
            document.getElementById("elementIdSpeedRatioMetric").innerHTML = "&nbsp;";
        }
        if (pitchDiameterA) {
            document.getElementById("elementIdPitchAMetric").innerHTML = (pitchDiameterA * 25.4).toFixed(1);
        } else {
            document.getElementById("elementIdPitchAMetric").innerHTML = "&nbsp;";
        }
        if (pitchDiameterB) {
            document.getElementById("elementIdPitchBMetric").innerHTML = (pitchDiameterB * 25.4).toFixed(1);
        } else {
            document.getElementById("elementIdPitchBMetric").innerHTML = "&nbsp;";
        }
        if (desiredBeltLength && beltLength) {
            document.getElementById("elementIdDesiredBeltPitchMetric").innerHTML = (desiredBeltLength * 25.4).toFixed(1);
            document.getElementById("elementIdBeltPitchMetric").innerHTML = beltLengthMetric;
        } else {
            document.getElementById("elementIdDesiredBeltPitchMetric").innerHTML = "&nbsp;";
            document.getElementById("elementIdBeltPitchMetric").innerHTML = "&nbsp;";
        }
        if (beltTeeth) {
            document.getElementById("elementIdBeltTeethMetric").innerHTML = beltTeeth;
        } else {
            document.getElementById("elementIdBeltTeethMetric").innerHTML = "&nbsp;";
        }
        if (centerDistance) {
            document.getElementById("elementIdActualCenterDistanceMetric").innerHTML = (centerDistance * 25.4).toFixed(1);
        } else {
            document.getElementById("elementIdActualCenterDistanceMetric").innerHTML = "&nbsp;";
        }
        if (teethInMesh) {
            document.getElementById("elementIdTeethInMeshMetric").innerHTML = teethInMesh;
            if (teethInMesh < 6) {
                document.getElementById("teethInMeshWarningMetric").innerHTML = "* Warning: A value for teeth in mesh below 6 may not be suitable for most applications.";
                document.getElementById("elementIdTeethInMeshMetric").className = "teethInMeshOob";
                document.getElementById("teethInMeshWarningMetric").className = "teethInMeshOob";
            } else {
                document.getElementById("teethInMeshWarningMetric").innerHTML = "&nbsp;";
                document.getElementById("elementIdTeethInMeshMetric").className = "teethInMeshNorm";
                document.getElementById("teethInMeshWarningMetric").className = "teethInMeshNorm";
            }
        } else {
            document.getElementById("elementIdTeethInMeshMetric").innerHTML = "&nbsp;";
            document.getElementById("teethInMeshWarningMetric").innerHTML = "&nbsp;";
            document.getElementById("elementIdTeethInMeshMetric").className = "teethInMeshNorm";
            document.getElementById("teethInMeshWarningMetric").className = "teethInMeshNorm";
        }
    }
  
  	var productSKU = "";
  
  	
    // locator
    if (configurator.getAttributeValue("ue").isSelected) {
        if (configurator.getAttribute("aToothStyle") && beltLength &&
                configurator.getAttribute("aBeltWidthEnglish").selectedValue) {
          
          var beltWidth = "";
          switch(configurator.getAttribute("aBeltWidthEnglish").selectedValue.label){
            case "3": beltWidth = "-300"; break;
            case "2": beltWidth = "-200"; break;
            case "1.5": beltWidth = "-150"; break;
            case "1": beltWidth = "-100"; break;
            case "0.75": beltWidth = "-075"; break;
            case "0.5": beltWidth = "-050"; break;
            case "0.375": beltWidth = "-037"; break;
            default: beltWidth = ""; break;
          }
          var skuSearchUrlTemplate = "/search?type=product&q=variants.sku:[[sku]]&view=sku";
          var productUrlTemplate = "/products/[[handle]]";
          
          productSKU = beltLength + "0-" + catalogToothStyles[configurator.getAttribute("aToothStyle").selectedValue.label] + beltWidth;
          var skuSearchUrl = skuSearchUrlTemplate.replace("[[sku]]",productSKU);
          var productHandle = "";
          $.getJSON( skuSearchUrl, function( data ) {
            if( data && data.products.length > 0 ){
              console.log(data.products[0].handle);
              productHandle = data.products[0].handle;
              let productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
              document.getElementById("locatorHrefBelt").innerHTML = "Click here to select an appropriate belt";
              document.getElementById("locatorHrefBelt").setAttribute("href", productUrl);
            } else {
              //let's try one size above
              let productSKUPlus = ( beltLength + 1 ) + "0-" + catalogToothStyles[configurator.getAttribute("aToothStyle").selectedValue.label] + beltWidth;
              let skuSearchUrlPlus = skuSearchUrlTemplate.replace("[[sku]]",productSKUPlus);
              $.getJSON( skuSearchUrlPlus, function( data ) {
                if( data && data.products.length > 0 ){
                  productHandle = data.products[0].handle;
                  let productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
				  document.getElementById("locatorHrefBelt").innerHTML = "Click here to select an appropriate belt";
                  document.getElementById("locatorHrefBelt").setAttribute("href", productUrl);
                } else {
                  //let's try one size below
                  let productSKUMinus = ( beltLength - 1 ) + "0-" + catalogToothStyles[configurator.getAttribute("aToothStyle").selectedValue.label] + beltWidth;
                  let skuSearchUrlMinus = skuSearchUrlTemplate.replace("[[sku]]",productSKUMinus);
                  $.getJSON( skuSearchUrlMinus, function( data ) {
                    if( data && data.products.length > 0 ){
                      productHandle = data.products[0].handle;
                      let productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
                      document.getElementById("locatorHrefBelt").innerHTML = "Click here to select an appropriate belt";
                      document.getElementById("locatorHrefBelt").setAttribute("href", productUrl);
                    } else {
                      //change the link to a Contact us
                      document.getElementById("locatorHrefBelt").innerHTML = "We could not find the appropriate belt size. Click here to contact us";
                      document.getElementById("locatorHrefBelt").setAttribute("href", "/pages/contact-us");
                    }
                  });
                }
              }); 
            }
          });
          
          productSKU = teethA + "-" + catalogToothStyles[configurator.getAttribute("aToothStyle").selectedValue.label] + beltWidth;
      	  var skuSearchUrl = skuSearchUrlTemplate.replace("[[sku]]",productSKU);
          var productHandle = "";
          $.getJSON( skuSearchUrl, function( data ) {
            if( data && data.products.length > 0 ){
              console.log(data.products[0].handle);
              productHandle =  data.products[0].handle;
              var productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
              document.getElementById("locatorHrefPulleyA").setAttribute("href", productUrl);
            }
          });
          

          productSKU = teethB + "-" + catalogToothStyles[configurator.getAttribute("aToothStyle").selectedValue.label] + beltWidth;
          var skuSearchUrl = skuSearchUrlTemplate.replace("[[sku]]",productSKU);
          var productHandle = "";
          $.getJSON( skuSearchUrl, function( data ) {
            if( data && data.products.length > 0 ){
              console.log(data.products[0].handle);
              productHandle =  data.products[0].handle;
              var productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
              document.getElementById("locatorHrefPulleyB").setAttribute("href", productUrl);
            }
          });
          console.log(productHandle);
          
          
          document.getElementById("locatorTable").style.display = "";
        } else {
          document.getElementById("locatorTable").style.display = "none";
        }
    } else {
      
      if (configurator.getAttribute("aToothStyle") && beltLengthMetric &&
          configurator.getAttribute("aBeltWidthMetric").selectedValue) {
    
		var beltWidth = configurator.getAttribute("aBeltWidthMetric").selectedValue.label;
        if(beltWidth.length == 1) beltWidth = "0" + beltWidth; 
        
        var toothStyle = "";
        console.log(configurator.getAttribute("aToothStyle").selectedValue.label);
        switch(configurator.getAttribute("aToothStyle").selectedValue.label){
          case "HTD 3mm": toothStyle = "-3M-"; break;
          case "HTD 5mm": toothStyle = "-5M-"; break;
          case "HTD 8mm": toothStyle = "-8M-"; break;
          case "GT 2mm": toothStyle = "-GT2-"; break;
          case "GT 3mm": toothStyle = "-14M-"; break;
          case "GT 5mm": toothStyle = "-14M-"; break;
          case "GT 8mm": toothStyle = "-14M-"; break;
          case "GT 14mm": toothStyle = "-14M-"; break;
          case "GT2 8mm": toothStyle = "-14M-"; break;
          case "GT2 14mm": toothStyle = "-14M-"; break;
          case "T2.5mm": toothStyle = "-T2.5-"; break;
          case "T5mm": toothStyle = "-T5-"; break;
          case "T10mm": toothStyle = "-T10-"; break;
          case "AT5mm": toothStyle = "-AT5-"; break;
          case "AT10mm": toothStyle = "-AT10-"; break;
          default: toothStyle = ""; break;
        }

        var skuSearchUrlTemplate = "/search?type=product&q=variants.sku:[[sku]]&view=sku";
        var productUrlTemplate = "/products/[[handle]]";

        productSKU = beltLengthMetric + toothStyle + beltWidth;
        var skuSearchUrl = skuSearchUrlTemplate.replace("[[sku]]",productSKU);
        var productHandle = "";
        $.getJSON( skuSearchUrl, function( data ) {
          if( data && data.products.length > 0 ){
            console.log(data.products[0].handle);
            productHandle = data.products[0].handle;
            let productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
            document.getElementById("locatorHrefBelt").innerHTML = "Click here to select an appropriate belt";
            document.getElementById("locatorHrefBelt").setAttribute("href", productUrl);
          } else {
            //let's try one size above
            let productSKUPlus = ( beltLengthMetric + 1 ) + toothStyle + beltWidth;
            let skuSearchUrlPlus = skuSearchUrlTemplate.replace("[[sku]]",productSKUPlus);
            $.getJSON( skuSearchUrlPlus, function( data ) {
              if( data && data.products.length > 0 ){
                productHandle = data.products[0].handle;
                let productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
                document.getElementById("locatorHrefBelt").innerHTML = "Click here to select an appropriate belt";
                document.getElementById("locatorHrefBelt").setAttribute("href", productUrl);
              } else {
                //let's try one size below
                let productSKUMinus = ( beltLengthMetric - 1 ) + toothStyle + beltWidth;
                let skuSearchUrlMinus = skuSearchUrlTemplate.replace("[[sku]]",productSKUMinus);
                $.getJSON( skuSearchUrlMinus, function( data ) {
                  if( data && data.products.length > 0 ){
                    productHandle = data.products[0].handle;
                    let productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
                    document.getElementById("locatorHrefBelt").innerHTML = "Click here to select an appropriate belt";
                    document.getElementById("locatorHrefBelt").setAttribute("href", productUrl);
                  } else {
                    //change the link to a Contact us
                    document.getElementById("locatorHrefBelt").innerHTML = "We could not find the belt size. Click here to contact us";
                    document.getElementById("locatorHrefBelt").setAttribute("href", "/pages/contact-us");
                  }
                });
              }
            }); 
          }
        });

        productSKU = teethA + toothStyle + beltWidth;
        var skuSearchUrl = skuSearchUrlTemplate.replace("[[sku]]",productSKU);
        var productHandle = "";
        $.getJSON( skuSearchUrl, function( data ) {
          if( data && data.products.length > 0 ){
            console.log(data.products[0].handle);
            productHandle =  data.products[0].handle;
            var productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
            document.getElementById("locatorHrefPulleyA").setAttribute("href", productUrl);
          }
        });          

        productSKU = teethB + toothStyle + beltWidth;
        var skuSearchUrl = skuSearchUrlTemplate.replace("[[sku]]",productSKU);
        var productHandle = "";
        $.getJSON( skuSearchUrl, function( data ) {
          if( data && data.products.length > 0 ){
            console.log(data.products[0].handle);
            productHandle =  data.products[0].handle;
            var productUrl = productUrlTemplate.replace("[[handle]]",productHandle);
            document.getElementById("locatorHrefPulleyB").setAttribute("href", productUrl);
          }
        });


        document.getElementById("locatorTable").style.display = "";
      } else {
        document.getElementById("locatorTable").style.display = "none";
      }
    }
}

